import Vue from 'vue';
import App from './App.vue';
import router from "@/routes";
import store from "./store/store";
import '@fortawesome/fontawesome-free/css/all.css';
import '@fortawesome/fontawesome-free/js/all.js';
import axios from 'axios';
import RegionDropdown from '@/shared/components/filters/RegionDropdown';
import GeneralStatusDropdown from '@/shared/components/filters/GeneralStatusDropdown';
import TeamProfessionDropdown from '@/shared/components/filters/TeamProfessionDropdown';
import CountryDropdown from '@/shared/components/filters/CountryDropdown';
import CarCategoryDropdown from '@/shared/components/filters/CarCategoryDropdown';
import CarStatusDropdown from '@/shared/components/filters/CarStatusDropdown';
import CarTypeDropdown from '@/shared/components/filters/CarTypeDropdown';
import TeamDropdown from '@/shared/components/filters/TeamDropdown';
import UserRoleDropdown from '@/shared/components/filters/UserRoleDropdown';
import CompanyDropdown from '@/shared/components/filters/CompanyDropdown';
import ProfessionDropdown from '@/shared/components/filters/ProfessionDropdown'

// register global components
Vue.component('RegionDropdown', RegionDropdown);
Vue.component('GeneralStatusDropdown', GeneralStatusDropdown);
Vue.component('TeamProfessionDropdown', TeamProfessionDropdown);
Vue.component('TeamDropdown', TeamDropdown);
Vue.component('CountryDropdown', CountryDropdown);
Vue.component('CarCategoryDropdown', CarCategoryDropdown);
Vue.component('CarStatusDropdown', CarStatusDropdown);
Vue.component('CarTypeDropdown', CarTypeDropdown);
Vue.component('UserRoleDropdown', UserRoleDropdown);
Vue.component('CompanyDropdown', CompanyDropdown);
Vue.component('ProfessionDropdown', ProfessionDropdown);

Vue.config.productionTip = false;
Vue.config.devtools = false;

axios.defaults.baseURL = '/api';
axios.defaults.withCredentials = false;
axios.interceptors.response.use(response => {
    return response;
}, error => {
    if (error.response.status === 401) {
        router.push('/login');
    } else {
        throw error;
    }
});

new Vue({
    store,
    router,
    render: h => h(App)
}).$mount('#app');
